var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('button',{on:{"click":_vm.login}},[_vm._v("Login")]),(_vm.isLogin)?_c('button',{on:{"click":_vm.logout}},[_vm._v("Logout")]):_vm._e(),_c('p',[_vm._v("Login Google? "+_vm._s(_vm.isLogin))])])}
var staticRenderFns = []

export { render, staticRenderFns }